import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
// @ts-ignore-next-line importsNotUsedAsValues
import 'react';
import classNames from 'classnames';
import { useDialogContext } from './dialogContext';
const DialogFooter = (props) => {
    const { className = '', children } = props, remainingProps = __rest(props, ["className", "children"]);
    const { isSmallestDialog, showXsDialogBorders } = useDialogContext();
    const doShowXsDialogBorders = isSmallestDialog ? showXsDialogBorders : true;
    const footerClassNames = classNames('modal-footer', !doShowXsDialogBorders && 'border-top-none padding-top-0', className);
    return (_jsx("div", Object.assign({}, remainingProps, { className: footerClassNames, "aria-label": 'dialog footer' }, { children: children })));
};
export default DialogFooter;
